import { skipToken, useQuery } from "@tanstack/react-query";
import { raffleKeys } from "Api/Queries/Raffle/useRaffleCurrentQuery";
import { useCheckPermission } from "Hooks/usePermission";
import { getRaffleHistory, Permission } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { AccessRightCodes } from "Models/AccessRightCodes";
import { MS_TIME } from "Utils/TimeUtils";

export const useRaffleHistoryQuery = () => {
  // Same gate as useRaffleCurrentQuery.
  const canRead = useCheckPermission(AccessRightCodes.Raffle, Permission.Read);

  return useQuery({
    queryKey: raffleKeys.history(),
    queryFn: canRead
      ? processResponseWithApiProblemDetails(() => getRaffleHistory())
      : skipToken,
    staleTime: MS_TIME.minute,
  });
};
